import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from "rxjs/operators";
import { AuthService } from '../services/auth.service';
import { ToasterService } from '../services/toaster.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toaster: ToasterService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        (event) => {},
        (error) => {
          if (error instanceof HttpErrorResponse) {
            switch (error.status) {
              case 400:
                if (error.error.message != null) {
                  this.toaster.openSnackBar(error.error.message, "");
                }
              break
              case 401:
                this.toaster.openSnackBar("Authentication has expired. Please login and authenticate again.", "Ok")
                this.authService.doLogout();
                break
              case 403:
                if (error.error === null){
                  this.toaster.openSnackBar("Invalid Username or Password", "Ok")
                }
                break;
              default:
                break;
            }
          }
        }
      )
    );
  }
}